import { render, staticRenderFns } from "./WorkShiftRequests.vue?vue&type=template&id=22f46799"
import script from "./WorkShiftRequests.vue?vue&type=script&lang=js"
export * from "./WorkShiftRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports